import { api } from '../../fetchWrapper';
import { getEndpoint } from '../../apiConstants';
import { API_ENDPOINTS } from '../../apiConstants';
import { ParseTemplatePayload, ParseTemplateApiResponse, ParseTemplateData } from './parseTemplate.types';

// Transform API response to clean UI data
const transformParseTemplate = (response: ParseTemplateApiResponse, template: string, holder: string): ParseTemplateData => {
  // Handle both JSON response and plain string response
  let parsedResult = '';
  let isSuccess = true;
  let errorMessage = '';

  if (typeof response === 'string') {
    // Backend returns plain string
    parsedResult = response;
    isSuccess = true;
  } else if (response && typeof response === 'object') {
    // Backend returns JSON object
    parsedResult = response.result || '';
    isSuccess = response.success !== false;
    errorMessage = response.error || '';
  } else {
    // Fallback
    parsedResult = String(response);
    isSuccess = true;
  }

  return {
    template,
    holder,
    parsedResult,
    isSuccess,
    errorMessage
  };
};

// Parse Template API
export const parseTemplateApi = {
  parse: async ({ 
    clientCode, 
    payload 
  }: { 
    clientCode: string; 
    payload: ParseTemplatePayload 
  }): Promise<ParseTemplateData> => {
    try {
      const endpoint = getEndpoint(clientCode, API_ENDPOINTS.ONLINE_TEMPLATE.PARSE_TEMPLATE);
      
      
      // Make direct fetch call to handle string response
      const token = localStorage.getItem("access_token");
      const headers: Record<string, string> = {
        'Content-Type': 'application/json',
      };
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }

      const response = await fetch(`/api/projectag${endpoint}`, {
        method: 'POST',
        headers,
        body: JSON.stringify([payload.template, payload.holder])
      });

      if (!response.ok) {
        throw new Error(`API request failed: ${response.status} ${response.statusText}`);
      }

      // Get response as text since backend returns plain string
      const responseText = await response.text();
      
      
      return transformParseTemplate(responseText, payload.template, payload.holder);
    } catch (error) {
      
      return {
        template: payload.template,
        holder: payload.holder,
        parsedResult: '',
        isSuccess: false,
        errorMessage: error instanceof Error ? error.message : 'Failed to parse template'
      };
    }
  }
};

// Legacy exports for backward compatibility
export const parseTemplate = parseTemplateApi.parse; 